export default __webpack_public_path__ + "static/ce93d438e0fe12935346adb6161bbbd8.png";